<template>
  <div>
    <ion-grid>
      <ion-row>
        <ion-col>
          <h5>Bridge Authentication</h5>
          
          <ion-list>
            <template v-if="busy">
              <ion-spinner class="small-spinner" />
            </template>
            <template v-else-if="beacon">
              <template v-if="beacon.offline">
                <ion-item>
                  <ion-icon
                    class="mr-2"
                    :src="i.cloudOfflineOutline"
                  />
                  Bridge is offline
                </ion-item>
              </template>
              <template v-else>
                <ion-item v-if="beacon.configured">
                  <ion-icon :src="i.checkmark" /> Bridge is configured
                </ion-item>
                <ion-item v-else>
                  <ion-icon :src="i.closeOutline" /> Bridge is not configured
                </ion-item>

                <ion-item v-if="beacon.canRecover">
                  <ion-icon :src="i.checkmark" /> Bridge can be recovered via e-mail by owner
                </ion-item>
                <ion-item v-else>
                  <ion-icon :src="i.closeOutline" /> Bridge recovery e-mail not set
                </ion-item>

                <ion-item v-if="getRecoveryEnabled">
                  <ion-label class="ion-text-wrap">
                    <strong>Recovery link</strong>
                    <p v-if="!recoveryLink">
                      <ion-button @click="confirmGetRecoveryLink">
                        <ion-spinner v-if="gettingRecoveryLink" />
                        <template v-else>
                          Get Recovery link
                        </template>
                      </ion-button>
                    </p>
                    <p v-else>
                      {{ recoveryLink }}
                    </p>
                  </ion-label>
                </ion-item>
              </template>
            </template>
          </ion-list>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { alertController } from '@modus/ionic-vue'

export default {
  data() {
    return {
      busy: false,
      serialNumber: this.$route.params.serialNumber,
      recoveryLink: null,
      gettingRecoveryLink: false,
    }
  },
  computed: {
    ...mapGetters([
      'getBridgeBySerial',
      'getBeaconBySerial',
    ]),
    bridge() {
      return this.$store.getters.getBridgeBySerial(this.serialNumber)
    },
    beacon () {
      return this.$store.getters.getBeaconBySerial(this.serialNumber)
    },
    getRecoveryEnabled () {
      return this.beacon.configured || this.bridge.is_virtual
    }
  },
  async mounted () {
    this.busy = true
    await this.$store.dispatch('fetchVpnBeacon', { serialNumber: this.serialNumber })
    this.busy = false
  },
  methods: {
    async confirmGetRecoveryLink() {
      let confirm = await alertController
          .create({
            header: `Get Recovery link`,
            message: `Warning: Creating a recovery link invalidates all previously created recovery links, even those
              requested by the owner of a Bridge. Continue?`,
            buttons: [
              {
                text: 'No',
                role: 'cancel'
              },
              {
                text: 'Yes',
                handler: () => {
                  this.getRecoveryLink()
                }
              }
            ],
          })
      confirm.present()
    },
    async getRecoveryLink () {
      this.gettingRecoveryLink = true
      try {
        this.recoveryLink = await this.$store.dispatch('fetchRecoveryLink', { serialNumber: this.serialNumber })
      } catch (e) {
        // ignore
      }
      this.gettingRecoveryLink = false
    },
  }
}
</script>

<style scoped>
ion-grid {
  width:100%;
}

ion-textarea {
  border: 1px solid rgba(0, 0, 0, 0.13);
}

code, ion-badge {
  margin-left:5px;
}

.card-content-md h5 {
  font-size: 18px;
  margin-top:16px;
}

.egro-header {
  --padding-start:0;
  --border-style:none;
}

.egro-header h5 {
  color:#737373;
}
</style>

<style>
ion-tab.ion-page {
  position:static;
  contain: inherit;
}

.egro-header ion-spinner {
  width:12px;
}

iframe {
  width:100%;
  height:600px;
  border:none;
}
</style>